exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".health-score-header{margin:20px 20px 0px 20px}.health-score-header svg{color:#54c2b6}.health-score-header .health-score{display:inline-block;min-width:1.5em;position:relative;font-family:700;position:relative;font-size:96px;overflow:hidden}.health-score-header .health-score:before{position:absolute;top:0px;right:0px;background:linear-gradient(90deg, #F2F2F2 25%, #E0E0E0 50%, #F2F2F2 75%);opacity:.5;height:100%;width:400%;animation:moveGradient 1.5s linear infinite}.health-score-header .health-score.hs-loading:before{content:\"\"}.health-score-header .health-score.nodata{animation:fadein .5s forward ease-in-out 1}.health-score-header .health-score.error{font-size:14px}.health-score-header .health-score.score-wrapper{font-size:96px}.health-score-header~div,.health-score-header *{position:relative}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};